import { UploadShareholdersExcelResponse } from "@/api/ApiService.ts";
import { Alert } from "@/components-v2/Alert";
import { Box, Grid, VBox } from "@/components-v2/Box";
import { Dialog } from "@/components-v2/Dialog";
import { useTranslation } from "@/stores/RootStoreContext";
import { observer } from "mobx-react";
import { FC, Fragment } from "react";
import {
  shareholderExcelResultCounts,
  shareholderExcelResultOutcome,
} from "./shareholderExcelResultDomain.ts";

export const ShareholderExcelResultDialog: FC<{
  result: UploadShareholdersExcelResponse;
  onClose: () => void;
}> = observer(({ result, onClose }) => {
  const { t } = useTranslation();
  const outcome = shareholderExcelResultOutcome(result);
  return (
    <Dialog
      title={t("shareholders.excel-result.title")}
      onCancel={onClose}
      cancelLabel={t("close")}
      maxWidth={"sm"}
    >
      <VBox gap={"lg"}>
        {outcome === "nothing-changed" && (
          <Alert type={"warning"} message={t("shareholders.excel-result.nothing-changed")} />
        )}
        <Grid cols={2} gap={"md"}>
          {shareholderExcelResultCounts(result).map((count) => (
            <Fragment key={count.key}>
              <Box fg={"subtle"}>{t(count.label)}</Box>
              <div>{count.value}</div>
            </Fragment>
          ))}
        </Grid>
        {result.unmatchedRowCount > 0 && (
          <Alert
            type={"warning"}
            message={t({
              key: "shareholders.excel-result.skipped-rows",
              params: { count: result.unmatchedRowCount },
            })}
          />
        )}
        {result.unmatchedRowCount === 0 && outcome === "changed" && (
          <Alert type={"success"} message={t("shareholders.excel-result.all-applied")} />
        )}
      </VBox>
    </Dialog>
  );
});
